var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "row lift lift-sm justify-content-center bg-white py-3 mb-3 rounded",
    },
    [
      _c(
        "div",
        {
          staticClass: "col-2 col-lg-1 text-right d-flex align-items-center",
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-icon",
              class: _vm.btn,
              attrs: {
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fas",
                class: _vm.icon,
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-8 col-lg-10",
        },
        [
          _c(
            "div",
            {
              staticClass: "text-lg",
            },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-break",
            },
            [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-2 col-lg-1 text-right",
        },
        [_c("small", [_vm._v(_vm._s(_vm.created_at))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }